export const BUDGET_CREATION_HEADER: Record<number, string> = {
  1: 'Create your Budget',
  2: 'Invite Member to Budget'
};

export const BUDGET_EDIT_HEADER: Record<number, string> = {
  1: 'Edit your Budget',
  2: 'Invite Member to Budget'
};
